<div *ngIf="session" class="ai-studio-layout session-host-active">
  <p-splitter [panelSizes]="splitterPanelSizes" [style]="{ height: '90vh' }" class="w-full">
    <ng-template #panel>
      <div class="card flex chat-pane">
        <!-- This container will grow to fill the space, providing a boundary for the scroll panel -->
        <div class="flex-grow-1" style="position: relative; overflow: hidden;">
          <!-- The scroll panel now fills this container, which has a defined height -->
          <p-scrollPanel #chatScrollPanel [style]="{width: '100%', height: '100%'}" styleClass="mb-2">
            <div class="chat-messages" #chatMessages>
              <div *ngFor="let message of session.chatMessages" 
                [class.user-message]="message.sender.id === currentUser.id"
                [class.other-message]="message.sender.id !== currentUser.id"
                [style.height.px]="message.chartContent ? 700 : null">
                <div class="message-sender-info">
                  <img [src]="message.sender.profilePictureUrl || 'assets/default-avatar.png'"
                    alt="{{ message.sender.fullName || 'User' }}'s avatar" class="sender-avatar">
                  <span class="message-sender-name">{{ message.sender.fullName || 'Unknown Sender' }}</span>
                </div>
                <!-- Old sender display, can be removed or kept for debugging if needed -->
                <!-- 
              <div class="message-sender">{{ message.sender.fullName }}</div> 
              -->
                <div [class]="message.sender.id === currentUser.id ? 'message-content-user' : 'message-content-bot'"
                [style.height.px]="message.chartContent ? 620 : null">
                  <ng-container *ngFor="let segment of message.segments">
                    <span *ngIf="segment.type === 'text'" [innerHTML]="segment.content"></span>
                    <p-chip *ngIf="segment.type === 'mention' && segment.user" [label]="segment.user.fullName"
                      [image]="segment.user.profilePictureUrl || 'assets/default-avatar.png'"
                      styleClass="inline-mention-chip">
                    </p-chip>
                  </ng-container>
                  <!-- Fallback if segments are not yet processed or message.textContent is the raw one -->
                  <ng-container *ngIf="!message.segments && message.textContent">
                    <span [innerHTML]="message.textContent"></span> <!-- You might need a pipe for this -->
                  </ng-container>
                  <ng-container *ngIf="message.activeCanvasPath && !message.workflowApprovals && !message.tableContent"
                    class="flex w-full">
                    <div class="flex flex-grow-none justify-content-end">
                      <p-button label="Open" icon="pi pi-window-maximize" variant="text"
                        (onClick)="navigateToCanvas(message.activeCanvasPath)" />
                    </div>
                  </ng-container>
                  <ng-container *ngIf="message.workflowApprovals" class="flex w-full">
                    <app-approval-card class="mt-4" [businessObjectId]="message.businessObject?.objectId ?? 0"
                      [businessObjectDescription]="message.businessObject?.objectDescription ?? ''" 
                      [currentUser]="currentUser"
                      [workflowApprovals]="message.workflowApprovals" (openDetails)="onOpenApprovalDetails($event)">
                    </app-approval-card>
                  </ng-container>
                  <ng-container *ngIf="message.tableContent">
                    <app-table-card [resourceName]="message.businessObject?.objectType ?? ''"
                        [tableContent]="message.tableContent" 
                        (openCanvasPage)="onViewTableDetails($event)">
                    </app-table-card>
                  </ng-container>
                  <ng-container *ngIf="message.chartContent">
                    <app-chart-card [title]="''" [chartContent]="message.chartContent" class="mt-4"></app-chart-card>
                  </ng-container>
                  <ng-container *ngIf="message.taskContent">
                    <app-task-card [task]="message.taskContent" class="mt-4"></app-task-card>
                  </ng-container>
                </div>
                <div *ngIf="message.fileUrlContent" class="message-content-bot">
                  <div class="col-12 flex overflow-hidden">
                    <div class="flex-none flex align-items-center justify-content-center">
                      <i *ngIf="message.fileNameContent" class="pi pi-file text-3xl mr-2"></i>
                      <img *ngIf="!message.fileNameContent" src="../assets/pdf_file_format.png" height="40" class="mr-2">
                    </div>
                    <div class="flex-1 flex align-items-center" style="min-width: 0">
                      <h4 class="ml-1 m-0 white-space-nowrap overflow-hidden text-overflow-ellipsis"
                        [title]="message.fileNameContent || 'Proof of Delivery'">
                        {{ message.fileNameContent || 'Proof of Delivery' }}</h4>
                    </div>
                    <div class="flex-none flex align-items-center justify-content-center">
                      <p-button label="Download" icon="pi pi-cloud-download"
                        (onClick)="downloadFile(message.fileUrlContent, message.fileNameContent)" severity="help" class="p-2"></p-button>
                    </div>
                  </div>
                </div>
                <div class="message-timestamp">{{ message.timestamp | date:'MMM-dd yyyy, h:mm a' }}</div>
              </div>
            </div>
          </p-scrollPanel>
        </div>
        <p-progressBar mode="indeterminate" class="mb-2" *ngIf="isLoading"></p-progressBar>

        <!-- Chat Input with @Mention -->
        <p-inputgroup class="chat-input-group pt-2">
          <p-inputgroup-addon class="chat-input-addon">
            <p-button icon="pi pi-microphone" label="Speak" class="w-full pr-6"
              [styleClass]="isListening ? 'p-button-danger' : 'p-button-help'"
              [style]="{'height': '45px', 'min-width': '105px'}" (click)="toggleSpeechRecognition()">
            </p-button>
          </p-inputgroup-addon>
          <p-autoComplete [(ngModel)]="chatPrompt" [suggestions]="suggestions"
            (completeMethod)="searchSuggestions($event)" (onSelect)="onSuggestionSelect($event)"
            [field]="isMentioning ? 'fullName' : 'command'" [forceSelection]="false" [showEmptyMessage]="false"
            [minLength]="1" class="w-full" placeholder="Type your message or @ to mention, / for commands..."
            [style]="{'width': '100%', 'height': '47px'}" (onKeyUp)="handleInput($event)" #autoComplete>
            <ng-template let-item pTemplate="item">
              <!-- User Mention Template -->
              <div *ngIf="isMentioning" class="mention-suggestion-item">
                <img [src]="item.profilePictureUrl || 'assets/default-avatar.png'" [alt]="item.fullName"
                  class="mention-avatar" />
                <span class="mention-name">{{item.fullName}}</span><br>
                <span class="mention-email"> ({{item.email}})</span>
              </div>
              <!-- Shortcut Command Template -->
              <div *ngIf="isShortcutMode" class="shortcut-suggestion-item">
                <span class="shortcut-command">{{item.command}}</span>
                <span class="shortcut-description">{{item.description}}</span>
              </div>
            </ng-template>
          </p-autoComplete>
          <p-inputgroup-addon class="chat-input-addon">
            <p-button label="Send" icon="pi pi-send" [style]="{'height': '45px', 'min-width': '105px'}"
              (click)="onSendButtonClick()" class="w-full pr-6"></p-button>
          </p-inputgroup-addon>
        </p-inputgroup>
      </div>
    </ng-template>
    <ng-template #panel>
      <div class="flex canvas-pane">
        <!-- Ensure this container fills the splitter panel and arranges children vertically -->
        <div class="surface-ground p-2 mb-2 flex flex-column w-full h-full">
          <div class="canvas-header">
            <p-toolbar>
              <div class="p-toolbar-group-start">
                <p-button icon="pi pi-arrow-left" styleClass="p-button-text p-button-plain"
                  (click)="goBack()"></p-button>
              </div>
              <div class="p-toolbar-group-end">
                <!-- These buttons can remain as is -->
                <p-button icon="pi pi-sync" #reloadBtn styleClass="p-button-text p-button-plain" (click)="reloadPage()"></p-button>
                <p-button icon="pi pi-ellipsis-v" styleClass="p-button-text p-button-plain"></p-button>
              </div>
            </p-toolbar>
          </div>
          <!-- This div will grow to fill available space and contain the scrollable area -->
          <div class="canvas-content flex-grow-1" style="position: relative; overflow: hidden;">
            <p-scrollPanel [style]="{width: '100%', height: '100%'}">
              <router-outlet name="canvasOutlet"></router-outlet>
            </p-scrollPanel>
          </div>
        </div>
      </div>
    </ng-template>
  </p-splitter>
</div>
<!-- Display when loading the specific session for this component -->
<div *ngIf="isLoadingCurrentSession" class="loading-session p-d-flex p-jc-center p-ai-center">
  <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8"
    animationDuration=".5s"></p-progressSpinner>
</div>
<!-- Display if session loading is complete but the session was not found -->
<div *ngIf="!isLoadingCurrentSession && !session" class="loading-session">Session not found or could not be loaded.
</div>